/**
 * Extract a human-readable message from an unknown thrown value.
 *
 * Reads `.message` off plain-object errors too: supabase-js throws
 * `PostgrestError` as a bare object, not an `Error`, so an
 * `instanceof Error` check loses the database message. `fallback`
 * substitutes whenever the value carries no usable message (including
 * an `Error` whose `.message` is empty).
 */
export function getErrorMessage(error: unknown, fallback = 'Unknown error'): string {
  if (error instanceof Error) return error.message || fallback;
  if (typeof error === 'object' && error !== null) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string' && message) return message;
  }
  if (typeof error === 'string' && error) return error;
  return fallback;
}
